const faqFilters = document.querySelectorAll('.faq-filter__input');

faqFilters.forEach(filter => {
	filter.addEventListener('change', (e) => {
		const filter = e.target.dataset.filter,
					toggles = document.querySelectorAll('.toggle--item');

		toggles.forEach(toggle => {
			let activeFilter = toggle.dataset.filter;
			
			if (filter === 'all') {
				toggle.classList.remove('hide');
			} else {
				if (activeFilter.includes(filter)) {
					toggle.classList.remove('hide');
				} else {
					toggle.classList.add('hide');
				}
			}
		});
	});
});